<template>
  <v-row
    v-if="showCaseLink || showImpairedRiskQuotes || showEapps"
    class="ma-0 pa-3 ga-1"
    justify="end"
  >
    <app-button
      v-if="showCaseLink"
      variant="outlined"
      data-testid="action-view-case"
      class="text-none rounded-pill"
      color="orange"
      text="View Case"
      :prepend-icon="mdiBriefcase"
      :to="getRouterLink('Case', quoteCase)"
    />

    <related-impaired-risk-quotes-button
      v-if="showImpairedRiskQuotes"
      :quotes="impairedRiskQuotes"
      @create="createImpairedRiskQuote"
    />

    <related-eapps-button
      v-if="showEapps"
      :block="smAndDown"
      :eapps="eApps"
      text="eApp"
      create-text="Create eApp"
      can-create
      :prepend-icon="quoteAndApplyIcon"
      @create="convertToEapp"
    />
  </v-row>
</template>

<script setup>
import RelatedEappsButton from "@/components/shared/actions/RelatedEappsButton.vue";
import ImpairedRiskQuoteCreate from "@/components/impaired-risk-quote/ImpairedRiskQuoteCreate.vue";
import RelatedImpairedRiskQuotesButton from "@/components/shared/actions/RelatedImpairedRiskQuotesButton.vue";

import { getRouterLink } from "@/util/helpers";
import { storeToRefs } from "pinia";
import { useDialogStore } from "@/stores/dialog";
import { useQuoteViewStore } from "@/stores/quote-view";
import { mdiBriefcase } from "@mdi/js";
import { computed, markRaw, ref } from "vue";
import { useQuoteAndApplyIcon } from "@/composables/quote-and-apply-icon.composable";
import { useDisplay } from "vuetify/lib/framework.mjs";
import ConfirmationDialog from "@/dialogs/ConfirmationDialog.vue";
import { useRouter } from "vue-router";
import { QUOTE_REQUEST_LINE } from "@/models/Quote";

const dialog = useDialogStore();
const quoteView = useQuoteViewStore();
const {
  eapp: quoteEapp,
  case: quoteCase,
  id,
  impairedRiskQuotes,
  line
} = storeToRefs(quoteView);

const router = useRouter();
const showCaseLink = computed(() => Boolean(quoteCase.value));
const quoteAndApplyIcon = useQuoteAndApplyIcon();
const { smAndDown } = useDisplay();

const showImpairedRiskQuotes = computed(() => line.value === "life");
const eApps = ref([]);

if (quoteEapp.value) eApps.value.push({ id: quoteEapp.value });

function createImpairedRiskQuote() {
  dialog.showDialog({
    component: markRaw(ImpairedRiskQuoteCreate),
    quoteId: id.value,
    scrollable: true,
    isDialog: true
  });
}

const showEapps = computed(() =>
  [
    QUOTE_REQUEST_LINE.ANNUITY,
    QUOTE_REQUEST_LINE.LIFE,
    QUOTE_REQUEST_LINE.LTC
  ].includes(line.value)
);
function convertToEapp() {
  dialog.showDialog({
    component: markRaw(ConfirmationDialog),
    title: "Would you like to create an eApp from this Quote?",
    subtitle: "Please confirm your intent.",
    func: async () => {
      const id = await quoteView.convertToEapp();
      router.push(getRouterLink("ElectronicApplication", id));
    }
  });
}
</script>
